import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { useTranslate } from 'src/locales';
import { useChannelContext } from 'src/pages/channel/hooks';

export function useTelegramStep2() {
  const { t } = useTranslate('translation');
  const {
    state: channelState,
    handleChannelName,
    handleTelegramDetail,
    onChangeStep,
  } = useChannelContext();

  const schema = z.object({
    channelName: z.string().min(1, { message: t('CHANNEL_NAME_REQUIRED') }),
    botToken: z.string().min(1, { message: t('TELEGRAM_BOT_TOKEN_REQUIRED') }),
  });

  type FormValues = z.infer<typeof schema>;

  const methods = useForm<FormValues>({
    mode: 'all',
    resolver: zodResolver(schema),
    defaultValues: {
      channelName: channelState.channelName || '',
      botToken: channelState.telegramBotToken || '',
    },
  });

  const { handleSubmit, watch, formState } = methods;

  const botToken = watch('botToken');
  const isFormValid = formState.isValid;

  const onSubmit = handleSubmit((data) => {
    handleChannelName(data.channelName);
    handleTelegramDetail(data.botToken);
    methods.reset();
    onChangeStep('next');
  });

  const isNextDisabled = !isFormValid || !botToken;

  return {
    methods,
    isNextDisabled,
    onSubmit,
  };
}
